import React from 'react';
import Footer2Component from '../commons/footer2';
import {IndexLink, Link, withRouter} from 'react-router';
import Carousel, { Dots } from '@brainhubeu/react-carousel';
import Icon from 'react-fa';
import '@brainhubeu/react-carousel/lib/style.css';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import axios from 'axios';

import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';

class ProjectPage extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);

        this.state = {
            service: '',
            opt_service: [],
            menuShow: false,
        }
    }

    arrowRendererOpt = () => {
        return (
            <img className="head_icon_search" src="/static/img/appimg/icon_search.png"/>
        );
    }

    handleServiceChange = (evt) => {
        let choose = evt.value;
        this.setState({service: choose});
    }

    getServiceOpt = (input, callback) => {
        if (input.length == 0) {
            this.setState({opt_service: this.state.opt_service});
        }
        else {
            let data = new FormData();
            data.append('search', input);
            axios.post('/code/apis.php?api=getParams&opt_param=job_function', data, {
                progress: (progressEvent) => {
                }
            })
                .then(response => {
                    if (response.data.status == 1) {
                        this.setState({opt_service: response.data.data});
                    } else {
                        this.setState({opt_service: []});
                    }
                    return response;
                })
                .catch(error => {
                    callback(null, {opt_service: []});
                });
        }
    }

    mouseClick = (evt) => {
        this.setState({menuShow: !this.state.menuShow})
    }

    mouseOut = (evt) => {
        this.setState({menuShow: false})
    }

    mouseLinkClick = (link, evt) => {
        this.props.router.push(link);
    }

    render() {
        if (isMobile) {
            return (
                <div>
                    <div className="advertise_boxx" id="a_project_mobile">
                        <div className={"block-001 row mr0"}>
                            <Link to="/"><img className={"img_logo"} alt="mini-internships" src="/static/img/homeimg/pj/project-support.png"/></Link>
                            <div className={"mobile-dropdown"}>
                                <svg onClick={() => this.mouseClick()} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="30" height="30" focusable="false">
                                    <title>Menu</title>
                                    <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeMiterlimit="10" d="M4 7h22M4 15h22M4 23h22"></path>
                                </svg>
                                <ul onMouseOut={() => this.mouseOut()} onMouseLeave={() => this.mouseOut()}  className={this.state.menuShow?"mobile-menu":"hide-el mobile-menu"}>
                                    <li onClick={() => this.mouseLinkClick("/business/signup")}><span>Join</span></li>
                                    <li onClick={() => this.mouseLinkClick("/projects/signin")}><span>Sign in</span></li>
                                </ul>
                            </div>
                            <div className="col-xs-12 text-center content">
                                <h2>Project Support<br/>On-Demand</h2>
                                <p>Versity helps you hire top college students.</p>
                                <div className="search-block row">
                                    <div className="col-xs-12 text-left pd7">
                                        <Select
                                            name="service"
                                            value={this.state.service}
                                            arrowRenderer={this.arrowRendererOpt}
                                            options={this.state.opt_service}
                                            onChange={this.handleServiceChange.bind(this)}
                                            onInputChange={this.getServiceOpt.bind(this)}
                                            placeholder="What service industry do you need?"
                                            clearable={true}
                                            searchable={true}
                                        />
                                    </div>
                                    <div className="col-xs-12 text-center pd7">
                                        <Link className={"btn03"} to="/post">Get started</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="block-content mrlr-10">
                            <div className={"block-003 pd-block"}>
                                <span className="title">Popular Projects</span>
                                <div className="col-xs-12 carausel-div pd0">
                                    <Carousel
                                        arrowLeft={<Icon name="angle-double-left" />}
                                        arrowLeftDisabled={<Icon name="angle-left" />}
                                        arrowRight={<Icon name="angle-double-right" />}
                                        arrowRightDisabled={<Icon name="angle-right" />}
                                        addArrowClickHandler
                                        slidesPerPage={2}
                                        infinite
                                    >
                                        <img className={"img_logo"} src="/static/img/homeimg/pj/p06.png"/>
                                        <img className={"img_logo"} src="/static/img/homeimg/pj/p07.png"/>
                                        <img className={"img_logo"} src="/static/img/homeimg/pj/p08.png"/>
                                        <img className={"img_logo"} src="/static/img/homeimg/pj/p09.png"/>
                                        <img className={"img_logo"} src="/static/img/homeimg/pj/p10.png"/>
                                        <img className={"img_logo"} src="/static/img/homeimg/pj/p01.png"/>
                                        <img className={"img_logo"} src="/static/img/homeimg/pj/p02.png"/>
                                        <img className={"img_logo"} src="/static/img/homeimg/pj/p03.png"/>
                                        <img className={"img_logo"} src="/static/img/homeimg/pj/p04.png"/>
                                        <img className={"img_logo"} src="/static/img/homeimg/pj/p05.png"/>
                                    </Carousel>
                                </div>
                            </div>
                        </div>
                        <div className={"block-004 pd-block row mrlr-10"}>
                            <div className="col-xs-12 pd0">
                                <span className="sub-title hide-el">What is a Mini-Internship?</span>
                                <ul>
                                    <li>
                                        <span><img className={"img_logo"} src="/static/img/homeimg/pj/point-i.png"/>Short-term Projects</span>
                                        <p>Are paid professional assignments given to college students and recent grads. </p>
                                    </li>
                                    <li>
                                        <span><img className={"img_logo"} src="/static/img/homeimg/pj/point-i.png"/>On-Demand</span>
                                        <p>They usually consist of 5 to 40 hours, and can occur any time of year.</p>
                                    </li>
                                    <li>
                                        <span><img className={"img_logo"} src="/static/img/homeimg/pj/point-i.png"/>Multiple Industries</span>
                                        <p>Businesses across a wide range of industries post projects for students to complete remotely.</p>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-xs-12 text-right pd0 mgt0">
                                <img className={"img_logo img_full"} src="/static/img/homeimg/pj/bg3.png"/>
                            </div>
                        </div>
                        <div className={"block-005 pd-block row mrlr-10"}>
                            <span className="title">Explore The Marketplace</span>
                            <div className="sub-block row">
                                <div className="col-xs-6 pd-bottom">
                                    <img className={"img_logo"} src="/static/img/homeimg/pj/e01.png"/>
                                    <span>Graphics & Design</span>
                                </div>
                                <div className="col-xs-6 pd-bottom">
                                    <img className={"img_logo"} src="/static/img/homeimg/pj/e02.png"/>
                                    <span>Digital Marketing</span>
                                </div>
                                <div className="col-xs-6 pd-bottom">
                                    <img className={"img_logo"} src="/static/img/homeimg/pj/e03.png"/>
                                    <span>Writing & Translation</span>
                                </div>
                                <div className="col-xs-6 pd-bottom">
                                    <img className={"img_logo"} src="/static/img/homeimg/pj/e04.png"/>
                                    <span>Video & Animation</span>
                                </div>
                                <div className="col-xs-6 pd-bottom">
                                    <img className={"img_logo"} src="/static/img/homeimg/pj/e05.png"/>
                                    <span>Music & Audio</span>
                                </div>
                                <div className="col-xs-6 pd-bottom">
                                    <img className={"img_logo"} src="/static/img/homeimg/pj/e06.png"/>
                                    <span>Programming & Tech</span>
                                </div>
                                <div className="col-xs-6 pd-bottom">
                                    <img className={"img_logo"} src="/static/img/homeimg/pj/e07.png"/>
                                    <span>Business</span>
                                </div>
                                <div className="col-xs-6 pd-bottom">
                                    <img className={"img_logo"} src="/static/img/homeimg/pj/e08.png"/>
                                    <span>Data Entry</span>
                                </div>
                            </div>
                        </div>
                        <div className={"block-004 pd-block row mrlr-10"}>
                            <div className="col-xs-12 pd0">
                                <span className="sub-title">Get Work Done Faster On Versity, With Confidence</span>
                                <ul>
                                    <li>
                                        <span><img className={"img_logo"} src="/static/img/homeimg/pj/point.png"/>Payment Protection, Guaranteed</span>
                                        <p>Payment is released to the freelancer once you're pleased and approve the work you get.</p>
                                    </li>
                                    <li>
                                        <span><img className={"img_logo"} src="/static/img/homeimg/pj/point.png"/>Name Your Price</span>
                                        <p>Find any service within minutes and know exactly what you'll pay. No hourly rates, just a fixed price.</p>
                                    </li>
                                    <li>
                                        <span><img className={"img_logo"} src="/static/img/homeimg/pj/point.png"/>We're Here For You 24/7</span>
                                        <p>Versity is here for you, anything from answering any questions to resolving any issues, at any time.</p>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-xs-12 text-right pd0 mgt0">
                                <img className={"img_logo img_full"} src="/static/img/homeimg/pj/bg2.png"/>
                            </div>
                        </div>
                        <div className={"block-006 pd-block row mrlr-10"}>
                            <span className="title">How It Works</span>
                            <div className="col-xs-12 pd-item text-center">
                                <img className={"img_logo"} src="/static/img/homeimg/pj/w001.png"/>
                                <span>Post a project</span>
                                <p>Tell us about your project. Versity<br/> connects you with top college talent.</p>
                            </div>
                            <div className="col-xs-12 pd-item text-center">
                                <img className={"img_logo"} src="/static/img/homeimg/pj/w002.png"/>
                                <span>Interns come to you</span>
                                <p>Select who you want without <br/>any HR or legal burdens.</p>
                            </div>
                            <div className="col-xs-12 pd-item text-center">
                                <img className={"img_logo"} src="/static/img/homeimg/pj/w003.png"/>
                                <span>Collaborate easily</span>
                                <p>Use Versity to chat, share files, and<br/> track project milestones.</p>
                            </div>
                            <div className="col-xs-12 pd-item text-center">
                                <img className={"img_logo"} src="/static/img/homeimg/pj/w004.png"/>
                                <span>Payment simplified</span>
                                <p>Pay fixed-price and receive invoices<br/> through Versity. Pay only for work you<br/> authorize.</p>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <div>
                <div className="advertise_boxx" id="a_project">
                    <div className={"block-001"}>
                        <Link to="/"><img className={"img_logo"} alt="mini-internships" src="/static/img/appimg/login_h_logo.png"/></Link>
                        <Link className="btn_login" to="/projects/signin">Sign in</Link>
                        <Link className="btn_join" to="/business/signup">Join</Link>
                        <div className="col-xs-12 text-center content">
                            <h2>Project Support On-Demand</h2>
                            <p>Versity helps you hire top college students.</p>
                            <div className="search-block row">
                                <div className="col-xs-8 text-left pd0">
                                    <Select
                                        name="service"
                                        value={this.state.service}
                                        arrowRenderer={this.arrowRendererOpt}
                                        options={this.state.opt_service}
                                        onChange={this.handleServiceChange.bind(this)}
                                        onInputChange={this.getServiceOpt.bind(this)}
                                        placeholder="What service industry do you need?"
                                        clearable={true}
                                        searchable={true}
                                    />
                                    </div>
                                <div className="col-xs-4 text-center pd0">
                                    <Link className={"btn03"} to="/post">Get started</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 text-center p-bottom pd0">
                            <Link className={"btn03"} to="/post"><span className="sfirst">Popular services</span></Link>
                            <Link className={"btn03"} to="/post"><span><img src="/static/img/homeimg/pj/t_01.png"/>Website Building</span></Link>
                            <Link className={"btn03"} to="/post"><span><img src="/static/img/homeimg/pj/t_02.png"/>Graphic Design</span></Link>
                            <Link className={"btn03"} to="/post"><span><img src="/static/img/homeimg/pj/t_03.png"/>Social Media Marketing</span></Link>
                            <Link className={"btn03"} to="/post"><span><img src="/static/img/homeimg/pj/t_04.png"/>Video Editing/Production</span></Link>
                            <Link className={"btn03"} to="/post"><span><img src="/static/img/homeimg/pj/t_05.png"/>Writing/Proofreading</span></Link>
                            <Link className={"btn03"} to="/post"><span><img src="/static/img/homeimg/pj/t_06.png"/>Data Entry</span></Link>
                            <Link className={"btn03"} to="/post"><span>...  See all services</span></Link>
                        </div>
                    </div>
                    <div className={"block-002"}>
                        <div className="sub-block">
                            <div className="col-xs-4 text-center">
                                <img className={"img_logo"} src="/static/img/homeimg/pj/tt01.png"/>
                                <span>Post your project for free</span>
                            </div>
                            <div className="col-xs-4 text-center">
                                <img className={"img_logo"} src="/static/img/homeimg/pj/tt02.png"/>
                                <span>Name your price</span>
                            </div>
                            <div className="col-xs-4 text-center">
                                <img className={"img_logo"} src="/static/img/homeimg/pj/tt03.png"/>
                                <span>Hire talented U.S students</span>
                            </div>
                        </div>
                    </div>
                    <div className="block-content">
                        <div className={"block-003 pd-block row"}>
                            <span className="title">Popular Projects</span>
                            <div className="col-xs-12 carausel-div pd0">
                                <Carousel
                                    arrowLeft={<Icon name="angle-double-left" />}
                                    arrowLeftDisabled={<Icon name="angle-left" />}
                                    arrowRight={<Icon name="angle-double-right" />}
                                    arrowRightDisabled={<Icon name="angle-right" />}
                                    addArrowClickHandler
                                    slidesPerPage={5}
                                    infinite
                                >
                                <img className={"img_logo"} src="/static/img/homeimg/pj/p06.png"/>
                                <img className={"img_logo"} src="/static/img/homeimg/pj/p07.png"/>
                                <img className={"img_logo"} src="/static/img/homeimg/pj/p08.png"/>
                                <img className={"img_logo"} src="/static/img/homeimg/pj/p09.png"/>
                                <img className={"img_logo"} src="/static/img/homeimg/pj/p10.png"/>
                                <img className={"img_logo"} src="/static/img/homeimg/pj/p01.png"/>
                                <img className={"img_logo"} src="/static/img/homeimg/pj/p02.png"/>
                                <img className={"img_logo"} src="/static/img/homeimg/pj/p03.png"/>
                                <img className={"img_logo"} src="/static/img/homeimg/pj/p04.png"/>
                                <img className={"img_logo"} src="/static/img/homeimg/pj/p05.png"/>
                                </Carousel>
                            </div>
                        </div>
                        <div className={"block-004 pd-block row mr0"}>
                            <div className="col-xs-6 pd0">
                                <span className="sub-title hide-el">What is a Mini-Internship?</span>
                                <ul>
                                    <li>
                                        <span><img className={"img_logo"} src="/static/img/homeimg/pj/point-i.png"/>Short-term Projects</span>
                                        <p>Are paid professional assignments given to college students and recent grads.</p>
                                    </li>
                                    <li>
                                        <span><img className={"img_logo"} src="/static/img/homeimg/pj/point-i.png"/>On-Demand</span>
                                        <p>They usually consist of 5 to 40 hours, and can occur any time of year.</p>
                                    </li>
                                    <li>
                                        <span><img className={"img_logo"} src="/static/img/homeimg/pj/point-i.png"/>Multiple Industries</span>
                                        <p>Businesses across a wide range of industries post projects for students to complete remotely.</p>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-xs-6 text-right pd0">
                                <img className={"img_logo img_full"} src="/static/img/homeimg/pj/bg3.png"/>
                            </div>
                        </div>
                        <div className={"block-005 pd-block row"}>
                            <span className="title">Explore The Marketplace</span>
                            <div className="sub-block">
                                <div className="col-xs-3 pd-bottom">
                                    <img className={"img_logo"} src="/static/img/homeimg/pj/e01.png"/>
                                    <span>Graphics & Design</span>
                                </div>
                                <div className="col-xs-3 pd-bottom">
                                    <img className={"img_logo"} src="/static/img/homeimg/pj/e02.png"/>
                                    <span>Digital Marketing</span>
                                </div>
                                <div className="col-xs-3 pd-bottom">
                                    <img className={"img_logo"} src="/static/img/homeimg/pj/e03.png"/>
                                    <span>Writing & Translation</span>
                                </div>
                                <div className="col-xs-3 pd-bottom">
                                    <img className={"img_logo"} src="/static/img/homeimg/pj/e04.png"/>
                                    <span>Video & Animation</span>
                                </div>
                                <div className="col-xs-3">
                                    <img className={"img_logo"} src="/static/img/homeimg/pj/e05.png"/>
                                    <span>Music & Audio</span>
                                </div>
                                <div className="col-xs-3">
                                    <img className={"img_logo"} src="/static/img/homeimg/pj/e06.png"/>
                                    <span>Programming & Tech</span>
                                </div>
                                <div className="col-xs-3">
                                    <img className={"img_logo"} src="/static/img/homeimg/pj/e07.png"/>
                                    <span>Business</span>
                                </div>
                                <div className="col-xs-3">
                                    <img className={"img_logo"} src="/static/img/homeimg/pj/e08.png"/>
                                    <span>Data Entry</span>
                                </div>
                            </div>
                        </div>
                        <div className={"block-004 pd-block row mr0"}>
                            <div className="col-xs-6 pd0">
                                <span className="sub-title">Get Work Done Faster On Versity, With Confidence</span>
                                <ul>
                                    <li>
                                        <span><img className={"img_logo"} src="/static/img/homeimg/pj/point.png"/>Payment Protection, Guaranteed</span>
                                        <p>Payment is released to the freelancer once you're pleased and approve the work you get.</p>
                                    </li>
                                    <li>
                                        <span><img className={"img_logo"} src="/static/img/homeimg/pj/point.png"/>Name Your Price</span>
                                        <p>Find any service within minutes and know exactly what you'll pay. No hourly rates, just a fixed price.</p>
                                    </li>
                                    <li>
                                        <span><img className={"img_logo"} src="/static/img/homeimg/pj/point.png"/>We're Here For You 24/7</span>
                                        <p>Versity is here for you, anything from answering any questions to resolving any issues, at any time.</p>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-xs-6 text-right pd0">
                                <img className={"img_logo img_full"} src="/static/img/homeimg/pj/bg2.png"/>
                            </div>
                        </div>
                        <div className={"block-006 pd-block row"}>
                            <span className="title">How It Works</span>
                            <div className="col-xs-3 pd-item text-center">
                                <img className={"img_logo"} src="/static/img/homeimg/pj/w001.png"/>
                                <span>Post a project</span>
                                <p>Tell us about your project. Versity<br/> connects you with top college talent.</p>
                            </div>
                            <div className="col-xs-3 pd-item text-center">
                                <img className={"img_logo"} src="/static/img/homeimg/pj/w002.png"/>
                                <span>Interns come to you</span>
                                <p>Select who you want without <br/>any HR or legal burdens.</p>
                            </div>
                            <div className="col-xs-3 pd-item text-center">
                                <img className={"img_logo"} src="/static/img/homeimg/pj/w003.png"/>
                                <span>Collaborate easily</span>
                                <p>Use Versity to chat, share files, and<br/> track project milestones.</p>
                            </div>
                            <div className="col-xs-3 pd-item text-center">
                                <img className={"img_logo"} src="/static/img/homeimg/pj/w004.png"/>
                                <span>Payment simplified</span>
                                <p>Pay fixed-price and receive invoices<br/> through Versity. Pay only for work you<br/> authorize.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"txtCenter"}>
                    <Footer2Component/>
                </div>
            </div>
        )
    }
}

ProjectPage.propTypes = {
    router: React.PropTypes.shape({
        push: React.PropTypes.func.isRequired
    }).isRequired
};

export default (withRouter(ProjectPage));



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/pages/project.js
 **/